import React, { useState } from 'react';
import { Button, Spin, Modal, Form, Input, message } from 'antd';
import { useDispatch } from 'react-redux';
import assign from 'lodash/assign';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { productMangement } from '../../redux/actions/productAction';
import { CATEGORY_CREATED_SUCCESS } from '../../constants/messages';

function AddGovermentCompliance(props) {
  const { refreshData, companyId } = props;
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const toggleLoginModal = () => {
    setShowLoginModal(!showLoginModal);
  };

  const onFinish = (values) => {
    const payload = assign(values, {
      company_id: companyId,
    });
    setLoading(true);
    dispatch(productMangement('create.government_compliance', payload))
      .then(() => {
        setLoading(false);
        toggleLoginModal();
        refreshData();
        message.success(CATEGORY_CREATED_SUCCESS);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        className="add-categoty-link"
        icon={<PlusOutlined />}
        onClick={toggleLoginModal}
        type="link"
      >
        Add New Goverment Compliance
      </Button>
      <Modal
        width="40%"
        className="common-modal product-image-modal "
        destroyOnClose
        closable={false}
        open={showLoginModal}
        onOk={toggleLoginModal}
        onCancel={toggleLoginModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container">
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleLoginModal();
                }}
              />
              Add New Goverment Compliance
            </div>
            <div className="mt-40">
              <Form
                name="basic"
                layout="horizontal"
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
                requiredMark={false}
              >
                <div className="mt-20">
                  <Form.Item
                    label="Goverment Compliance"
                    name="name"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input compliance name!',
                      },
                      {
                        min: 3,
                        message:
                          'Compliance name should be of atleast 3 character!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Compliance Name" />
                  </Form.Item>
                </div>
                <div className="mt-40">
                  <Form.Item
                    label="Description"
                    name="description"
                    className="form-item"
                  >
                    <Input.TextArea placeholder="Enter description" />
                  </Form.Item>
                </div>

                <div className="mt-20">
                  <Button type="primary" block htmlType="submit">
                    Create
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default AddGovermentCompliance;
